export default __webpack_public_path__ + "static/media/640_dummy2016-fotograf03-de.dbff34e1.png";